import { render } from "./roleAuthorization.vue?vue&type=template&id=9746d3d4&scoped=true"
import script from "./roleAuthorization.vue?vue&type=script&lang=js"
export * from "./roleAuthorization.vue?vue&type=script&lang=js"

import "./roleAuthorization.vue?vue&type=style&index=0&id=9746d3d4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9746d3d4"]])

export default __exports__